import { portMapping } from 'pando-constants';

export const portTypes = Object.entries(portMapping).map(val => ({ id: val[0], name: val[1] }));
